/**
 * EV-120。IME の変換中のキー操作か（isComposing、Safari・古い Chrome は keyCode 229）。
 * 変換中の Escape（変換の取り消し）・Enter（確定）・Tab・矢印キーは IME のものなので、
 * 画面の操作（ダイアログを閉じる・ボタンを押す・タブを移るなど）に使わない。
 */
export function isImeComposing(event: { isComposing?: boolean; keyCode?: number; nativeEvent?: unknown }): boolean {
  const native = (event.nativeEvent ?? event) as { isComposing?: boolean; keyCode?: number };
  return Boolean(event.isComposing || native.isComposing || event.keyCode === 229 || native.keyCode === 229);
}
